// Eskom PARCC — horizontal category bar chart (recharts).
//
// Used for breach-by-category (PFMA / Policy / Legislative) and division risk.
// Per-bar colours are passed in (theme-resolved). Interactive tooltip; the value
// label sits at the bar end. Pure presentational.
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, LabelList } from 'recharts';
import { ChartFrame } from './ChartFrame';

export interface CategoryDatum {
  label: string;
  value: number;
  colour: string;
}

export function CategoryBar({
  data,
  axisColour,
  gridColour,
  height = 200,
  valueSuffix = '',
}: {
  data: CategoryDatum[];
  axisColour: string;
  gridColour: string;
  height?: number;
  valueSuffix?: string;
}): React.JSX.Element {
  return (
    <div style={{ width: '100%', height }}>
      <ChartFrame>
        {({ width, height: h }) => (
          <BarChart
            width={width}
            height={h}
            data={data}
            layout="vertical"
            margin={{ top: 4, right: 28, bottom: 4, left: 8 }}
          >
            <XAxis type="number" hide />
            <YAxis
              type="category"
              dataKey="label"
              width={132}
              tickLine={false}
              axisLine={false}
              tick={{ fill: axisColour, fontSize: 12 }}
            />
            <Tooltip
              cursor={{ fill: gridColour }}
              formatter={(value) => [`${Number(value).toLocaleString('en-ZA')}${valueSuffix}`, 'Count']}
            />
            <Bar dataKey="value" radius={[4, 4, 4, 4]} barSize={16}>
              {data.map((d) => (
                <Cell key={d.label} fill={d.colour} />
              ))}
              <LabelList
                dataKey="value"
                position="right"
                formatter={(value) => `${Number(value).toLocaleString('en-ZA')}${valueSuffix}`}
                style={{ fill: axisColour, fontSize: 12, fontWeight: 600 }}
              />
            </Bar>
          </BarChart>
        )}
      </ChartFrame>
    </div>
  );
}
